import styled from '@emotion/styled';

export const TabText = styled.div<{
  isActive: boolean;
}>`
  padding-bottom: 10px;
  position: relative;

  &:after {
    content: ' ';
    display: block;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 2px;
    background: ${({ isActive }) => (isActive ? 'black' : 'transparent')};
  }
`;
